<template>
  <div class="login-page">
    <Login></Login>
  </div>
</template>

<script>
import Login from "../components/Auth/Login.vue";

export default {
  components: { Login },
  data() {
    return {};
  },
};
</script>

<style>
.login-page {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
